import '@fcms/ui/styles.css'

import { createPinia } from 'pinia'
import { createApp } from 'vue'

import App from './App.vue'
import { initI18n } from './i18n'
import router from './router'

const app = createApp(App)

app.use(createPinia())

/**
 * Locale, before the first paint.
 *
 * `initI18n()` constructs the `ui` store, which is what applies the persisted
 * locale through `@fcms/ui`'s `setLocale` — the single writer of
 * `<html lang>`/`<html dir>`, and therefore of every logical property in the
 * design system. Doing it here rather than letting the shell's first render
 * construct the store means a Dhivehi session never paints one frame of
 * left-to-right English. `index.html` sets the same attributes from
 * localStorage before the bundle loads; this is what keeps the store, the
 * message tree and those attributes agreeing from then on.
 */
initI18n()

app.use(router)

/**
 * The last line of defence.
 *
 * A component that throws during render leaves Vue with no tree to paint, and
 * the result is a white page with the error only in the console — which on a
 * supervisor's tablet at a jetty means nobody ever sees it. Logging it here
 * keeps the browser's own error reporting (and, in production, the log
 * pipeline behind it) fed. `AppShell` renders a recoverable error surface for
 * the same case via `onErrorCaptured`, so a user gets a way out as well.
 */
app.config.errorHandler = (error, _instance, info) => {
  console.error('[fcms] unhandled component error', info, error)
}

app.mount('#app')
